<script setup>
import { ref, computed } from "vue"
import Hero from "@common/js/components/administration/resale-agreements/common/Hero.vue"
import Contract from "@common/js/components/administration/resale-agreements/common/Contract.vue"
import { BoltIcon } from "@heroicons/vue/20/solid"
import Offers from "@/js/partials/resale-agreements/Offers.vue"
import { useI18n } from "vue-i18n"
import FeaturesAndAdvantages from "@common/js/components/administration/resale-agreements/common/FeaturesAndAdvantages.vue"
import ServiceClient from "@common/js/components/administration/resale-agreements/common/ServiceClient.vue"
import Price from "@common/js/components/administration/resale-agreements/common/Price.vue"

const { t } = useI18n()
const props = defineProps({
  isAuthenticated: { type: Boolean },
})
const heroSection = ref({
  title: t("common.administration.resale-agreements.my-kit-solar.hero.title"),
  heading: t(
    "common.administration.resale-agreements.my-kit-solar.hero.without-validate.heading"
  ),
  description: t(
    "common.administration.resale-agreements.my-kit-solar.hero.without-validate.description"
  ),
  btnColor: "#FF6E00",
  btnText: props.isAuthenticated
    ? t(
        "common.administration.resale-agreements.button.select-offer-for-solar-project"
      )
    : t("common.administration.resale-agreements.button.benefit-from-other"),
  btnText2: props.isAuthenticated
    ? ""
    : t(
        "common.administration.resale-agreements.button.photovoltaic-professional"
      ),
  btnTextColor: "#FFFFFF",
  logo: "https://images.ctfassets.net/1b6f0wuf6ave/6q1BqY5KfSxtS7Ryxw0Rwr/a8e4e820444a78c22432c30bd718a194/Group_3753.png",
  hasBadge: true,
  badgeIcon: BoltIcon,
  badgeText: t(
    "common.administration.resale-agreements.button.purchase-contract"
  ),
  isAuthenticated: props.isAuthenticated,
})

const contracts = ref({
  iconColor: "#130090",
  btnTextColor: "#FFFFFF",
  btnColor: "#FF6E00",
})

const serviceClient = ref({
  bgColor: "#130090",
  textColor: "#FFFFFF",
  contact: {
    title: t("common.administration.resale-agreements.contact"),
    heading: t(
      "common.administration.resale-agreements.my-kit-solar.service-client.title"
    ),
    email: "contact@monkitsolaire.fr",
    phone: "03 59 89 74 00",
    availability: t(
      "common.administration.resale-agreements.my-kit-solar.service-client.availability"
    ),
  },
})

const featuresAndAdvantages = ref({
  iconColor: "#130090",
  title: t(
    "common.administration.resale-agreements.my-kit-solar.feature-advantages.title"
  ),
  description: t(
    "common.administration.resale-agreements.my-kit-solar.feature-advantages.description"
  ),
  features: {
    "electrical-network": t(
      "common.administration.resale-agreements.my-kit-solar.feature-advantages.enedis"
    ),
    power: "0 kVA - 36 kVA",
    "customer-consumption": "Non",
    "rge-installer": "Non",
  },
  advantages: [
    t(
      "common.administration.resale-agreements.my-kit-solar.feature-advantages.same-energy"
    ),
    t(
      "common.administration.resale-agreements.my-kit-solar.feature-advantages.simple-purchase-price"
    ),
    t(
      "common.administration.resale-agreements.my-kit-solar.feature-advantages.simple-bank-transfer"
    ),
    t(
      "common.administration.resale-agreements.my-kit-solar.feature-advantages.without-subscription"
    ),
  ],
})
const pricingData = ref({
  description: t(
    "common.administration.resale-agreements.my-kit-solar.price.description"
  ),
  textColor: "#130090",
  btnColor: "#FF6E00",
  btnTextColor: "#FFFFFF",
  type: "FEED_IN_TARIFF",
  isCustom: false,
  lastUpdated: "25-05-2025",
  price: "0,10 € / kWh",
  link: "https://www.monkitsolaire.fr/content/147-mk-surplus",
  hasStartUpCost: true,
  startUpCost: "699 €",
})
</script>
<template>
  <div
    class="w-full max-w-7xl mx-auto pt-20 space-y-20 sm:space-y-[120px] mb-[120px] px-6 lg:px-8"
  >
    <Hero :data="heroSection" />
    <FeaturesAndAdvantages
      v-if="isAuthenticated"
      :data="featuresAndAdvantages"
    />
    <div
      class="flex xl:flex-row flex-col sm:items-start w-full gap-[50px] sm:!mt-20"
    >
      <div class="w-full">
        <div class="space-y-[30px]">
          <Price :data="pricingData"></Price>
        </div>
      </div>
    </div>
    <Contract v-if="!isAuthenticated" :data="contracts" />
    <ServiceClient :data="serviceClient" />
    <div class="text-center space-y-2.5">
      <h2
        class="text-[28px] sm:text-[35px] font-semibold text-gray-900 mb-2.5 leading-none"
      >
        {{ $t("common.administration.resale-agreements.compare-other-offers") }}
      </h2>
    </div>
    <Offers />
  </div>
</template>
<style scoped>
:deep(.offers) {
  padding: 0 !important;
  margin-top: 10px !important;
}
</style>
